import { Box } from "@chakra-ui/react";
import { FC, useMemo } from "react";

import { PageLayout } from "~/src/components/features/global/PageLayout";

export type Props = {
  siteSlug: string;
};

export const UrlMappingCreatePage: FC<
  React.PropsWithChildren<React.PropsWithChildren<Props>>
> = ({ children, siteSlug }) => {
  const breadcrumbs = useMemo(
    () => [
      {
        label: "URLマッピング",
        path: `/sites/${siteSlug}/settings?tab=url_mappings`,
      },
      {
        label: "URLマッピング登録",
        path: `/sites/${siteSlug}/url_mappings/new`,
      },
    ],
    [siteSlug]
  );

  return (
    <PageLayout title="URLマッピング登録" breadcrumbs={breadcrumbs}>
      <Box mt="32px">{children}</Box>
    </PageLayout>
  );
};
